import React from 'react';
import { func, object, string } from 'prop-types';
import { Box, Button } from '@mui/material';
import CachedRoundedIcon from '@mui/icons-material/CachedRounded';

import InputField from '../InputField';
import CopyButton from '../CopyButton';
import PermissionGate from '../PermissionGate';

import staticText from '../../localization/Application/Configuration/configuration';

const RegenerativeField = ({
  name,
  label,
  content,
  credentialsEvent,
  regenerateHandler,
  updateOnboardingEvent,
}) => {
  const sendOnboarding = updateOnboardingEvent && credentialsEvent.eventStatus === false;
  const updateCredentialsEvent = () => {
    updateOnboardingEvent(credentialsEvent.eventName);
  };

  const handleMouseUp = () => {
    const selection = window.getSelection().toString();

    if (content && selection === content) {
      updateCredentialsEvent();
    }
  };

  return (
    <InputField
      label={label}
      inputName={name}
      inputType={content ? 'text' : 'password'}
      inputValues={content || '************************************'}
      inputReadOnly
      InputProps={{ ...(sendOnboarding && { onMouseUp: handleMouseUp }) }}
      actions={(
        <Box display="flex" alignItems="center" gap={1}>
          <PermissionGate dashboardPermission="write_configuration">
            <Button
              id="regenerate-button"
              variant="outlined"
              onClick={regenerateHandler}
              size="small"
              startIcon={<CachedRoundedIcon fontSize="small" />}
            >
              {staticText.oauth.regenerate}
            </Button>
          </PermissionGate>
          {content && (
            <CopyButton
              content={content}
              onClick={sendOnboarding ? updateCredentialsEvent : null}
            />
          )}
        </Box>
      )}
    />
  );
};

export default RegenerativeField;

RegenerativeField.propTypes = {
  name: string,
  label: string,
  content: string,
  credentialsEvent: object,
  regenerateHandler: func.isRequired,
  updateOnboardingEvent: func,
};

RegenerativeField.defaultProps = {
  name: '',
  label: '',
  content: '',
  credentialsEvent: {},
  updateOnboardingEvent: null,
};

